import { TileIndex } from "../../types";

export const PLANNER_10: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 0, 2, 2, 20, 2, 0, 0, 0, 0, 0, 0, 27, 0, 0, 0, 0, 1, 1],
  [1, 1, 31, 2, 1, 1, 0, 1, 16, 16, 16, 16, 0, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 0, 2, 1, 1, 1, 1, 16, 31, 0, 16, 0, 1, 1, 1, 1, 1, 1, 1],
  [1, 1, 23, 23, 1, 1, 1, 1, 16, 16, 16, 16, 0, 1, 1, 1, 1, 15, 1, 1],
  [1, 1, 0, 2, 1, 16, 16, 16, 0, 30, 0, 19, 22, 22, 22, 20, 1, 2, 1, 1],
  [1, 1, 31, 2, 1, 16, 2, 16, 1, 12, 30, 0, 22, 22, 17, 20, 1, 2, 1, 1],
  [1, 1, 0, 2, 1, 16, 16, 16, 0, 0, 0, 0, 22, 22, 22, 20, 1, 2, 1, 1],
  [1, 1, 0, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 21, 1, 1],
  [1, 1, 0, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 21, 1, 1],
  [1, 1, 0, 23, 23, 23, 23, 23, 23, 0, 0, 23, 23, 23, 23, 23, 1, 21, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 16, 0, 1, 1, 1, 1, 1, 21, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 16, 16, 0, 22, 22, 22, 22, 22, 21, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]